import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faUtensils } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

import { Characteristic } from 'enums/characteristic';
import { ValueScope } from 'enums/valueScope';
import { getNumberString } from 'functions/numberToString';
import { getValueScopeLabel } from 'functions/valueScopeConversion';
import useCultureCode from 'hooks/redux/useCultureCode';

interface IProps {
	calories: number | null;
	characteristic: Characteristic;
}

const Calories = (props: IProps) => {
	const cultureCode = useCultureCode();

	if (props.calories) {
		return (
			<p>
				<span id="icon">
					<FontAwesomeIcon icon={faUtensils as IconProp} />
				</span>
				<b>{getNumberString(props.calories, cultureCode, true)}</b>
				{` ${t('_general:CALORIES')} ${getValueScopeLabel(
					ValueScope.HundredGrams,
					props.characteristic,
					true
				)}`}
			</p>
		);
	}
	return <></>;
};

export default Calories;
